import { AnyAction } from 'redux';
import { CONTRACT_NEW } from 'redux/actions/contract';
import {
	CONTRACT_PRICE_KPP_UPDATE,
	CONTRACT_PRICE_MOB_REFRESH,
	CONTRACT_PRICE_MWD_REFRESH,
	CONTRACT_PRICE_UPDATE,
	CONTRACT_PRICE_CALC,
	CONTRACT_PRICE_CALC_DONE,
	CONTRACT_PRICE_CALC_ERROR
} from 'redux/actions/contractPrices';
import {ContractPricesState} from '../../types/redux';

const initialState: ContractPricesState = {
	24: null,
	36: null,
	48: null,
	60: null,
	mob: null,
	mwd: null,
};

export function contractPricesReducer(
	state: ContractPricesState = initialState,
	action: AnyAction
): ContractPricesState {
	const newPrice = {};
	switch (action.type) {
		case CONTRACT_NEW:
		case CONTRACT_PRICE_MOB_REFRESH:
			return { ...initialState };
		case CONTRACT_PRICE_MWD_REFRESH:
			return { ...initialState };
		case CONTRACT_PRICE_UPDATE:
			newPrice[action.payload.key] = action.payload.price;
			return {
				...state,
				...newPrice,
			};
		case CONTRACT_PRICE_KPP_UPDATE:
			newPrice[action.payload.key] = action.payload.price;
			return {
				...state,
				...newPrice,
			};
		case CONTRACT_PRICE_CALC_ERROR:
			return { ...initialState };
		case CONTRACT_PRICE_CALC:
			return { ...state };
		case CONTRACT_PRICE_CALC_DONE:
			return { ...state};
		default:
			return state;
	}
}
